(function () {
  var SEL = '[data-earthday-reveal]';
  var READY = 'data-earthday-reveal-ready';

  function bindRoot(root) {
    if (!root || root.getAttribute(READY) === '1') return;
    root.setAttribute(READY, '1');

    function reveal() {
      if (root.classList.contains('is-revealed')) return;
      root.classList.add('is-revealed');
    }

    try {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        reveal();
        return;
      }
    } catch (e) {}

    if (!('IntersectionObserver' in window)) {
      reveal();
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            reveal();
            io.disconnect();
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -10% 0px' }
    );

    io.observe(root);
  }

  function scan() {
    document.querySelectorAll(SEL).forEach(bindRoot);
  }

  scan();

  if (!window.__earthdayRevealSectionHook) {
    window.__earthdayRevealSectionHook = true;
    document.addEventListener('shopify:section:load', scan);
  }
})();
